import React, { useCallback, useEffect } from 'react';
import { companyTypeInput } from '../data/searchFlowText';
import { useSelector, useDispatch } from 'react-redux';
import Navigation from '../components/navigation/navigation';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import axios from '../../utils/axiosCompanyProxy';
import ACTIONS from '../../../redux/action';
import RadioInput from '../components/searchInputs/radioInput';

const CompanyType = ({ ...props }) => {
	const [companyError, setCompanyError] = React.useState(false);
	const companyStore = useSelector((state) => state.company_store);
	const dispatch = useDispatch();

	// const handleNext = useCallback(
	//   (inc) => {
	//     props.handleNext(inc);
	//   },
	//   [props]
	// );
	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	const handleNext = useCallback(
		(e) => {
			props.handleNext(e);
		},
		[props]
	);

	const handleCompanyTypeChange = (value) => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'companytype',
				data: value,
				stateObject: 'company_store',
			})
		);
	};

	useEffect(() => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'leadtype',
				data: 'ASP',
				stateObject: 'company_store',
			})
		);
	}, [dispatch]);

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">{i18n.t('company.companyform')}</span>{' '}
					<span className="questionTracker">1/6</span>
				</p>

				<RadioInput
					storeID="companytype"
					dataText={companyTypeInput()}
					onChange={handleCompanyTypeChange}
				/>
			</div>
			<Navigation
				step={1}
				handleBack={() => handleBack()}
				handleNext={() => {
					handleNext(1);
				}}
				openHelpForm={() => props.openHelpForm()}
				disabledProp={companyStore.companytype === '' ? true : false}
			/>
		</div>
	);
};

export default withTranslation()(CompanyType);
